module.exports = __webpack_public_path__ + "static/media/file17.b1f508bd.jpg";